import { BaseEntityPage } from '../../components/common';
import ProvincesMergedContent from './components/ProvincesMergedContent';

export function ProvincesMergedPage() {
	return (
		<BaseEntityPage ContentComponent={ProvincesMergedContent} />
	);
}
